import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux-store/store";

const evaluationSelector = (state: RootState) => state.evaluation;

const formForwardCandidateSelector = createSelector(
  evaluationSelector,
  (state) => state.forwardEvaluationReducer
);

export const forwardEvaluationFormDataSelector = createSelector(
  formForwardCandidateSelector,
  (state) => state.formData
);

const listCandidateCampaignSelector = createSelector(
  evaluationSelector,
  (state) => state.getListReducer
);

export const listCandidateCampaignDataSelector = createSelector(
  listCandidateCampaignSelector,
  (state) => state.data
);

const getCvOfCampaignSelector = createSelector(
  evaluationSelector,
  (state) => state.getCvOfCampaignReducer
);

export const getCvOfCampaignDataSelector = createSelector(
  getCvOfCampaignSelector,
  (state) => state.data
);

export const getCvOfCampaignLoadingSelector = createSelector(
  getCvOfCampaignSelector,
  (state) => state.status
);

const getInfoSelectedCandidateSelector = createSelector(
  evaluationSelector,
  (state) => state.getInfoSelectedCandidateReducer
);

export const getInfoSelectedCandidateDataSelector = createSelector(
  getInfoSelectedCandidateSelector,
  (state) => state.data
);

export const getInfoSelectedCandidateLoadingSelector = createSelector(
  getInfoSelectedCandidateSelector,
  (state) => state.status
);

export const idSelectedCandidateSelector = createSelector(
  getInfoSelectedCandidateSelector,
  (state) => state.idSelectedCandidate
);

const detailCampaignSelector = createSelector(
  evaluationSelector,
  (state) => state.getDetailCampaignReducer
);

export const detailCampaignDataSelector = createSelector(
  detailCampaignSelector,
  (state) => state.data
);

export const detailCampaignLoadingSelector = createSelector(
  detailCampaignSelector,
  (state) => state.status
);

const detailEvaluationSelector = createSelector(
  evaluationSelector,
  (state) => state.getDetailEvaluationReducer
);

export const detailEvaluationDataSelector = createSelector(
  detailEvaluationSelector,
  (state) => state.data
);

export const eventsSelector = createSelector(
  evaluationSelector,
  (state) => state.filterEventsReducer.events
);

export const formFilterSelector = createSelector(
  evaluationSelector,
  (state) => state.filterEventsReducer.formFilter
);

export const formDetailInterviewSelector = createSelector(
  evaluationSelector,
  (state) => state.formDetailInterviewReducer.form
);

export const listProgramSelector = createSelector(
  evaluationSelector,
  (state) => state.getListProgramReducer.data
);
